import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { IProfile } from '../../../../../../services/common/profile'
import { UserEvents } from '../../user-events'

const mParticleEvents: any = new UserEvents()

export const SetAttributes = (profile?: IProfile) => {

    if (profile && profile.uuid) {
        mParticleEvents.setUserAttribute(key.CUSTOMER_ID, String(profile.uuid))
    }

}
